import { put, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../components/common/apiConfig";

  
  
  export const actionTypes = {
      selectInstruments:"[selectInstruments] Action",
      selectInstrumentsLoad:"[selectInstrumentsLoad] Action",
      selectInstrumentsAsync:"[selectInstrumentsAsync] Action",
      selectInstrumentsEmpty:"[selectInstrumentsEmpty] Action"
  }

  const initialState={
      data:[],
      size:5,
      total:0,
      loading:false
  }


  export const bourse_select_instruments_reducer = (state=initialState,{type,payload})=>{
    switch (type) {
        case actionTypes.selectInstruments:
          return {
            ...state,
            data: payload.results,
            total: payload.total 
            ? payload.total >10000
            ?10000
            :payload.total 
            : 0
          };
        case actionTypes.selectInstrumentsLoad:
          return {
            ...state,
            loading:payload
          };
        case actionTypes.selectInstrumentsEmpty:
          return initialState
        default:
          return state;
      }
  }



  function* handleWorker({ payload }) {
    yield put({type:actionTypes.selectInstrumentsLoad,payload:true})

    let config = {
      url: "select_request"
    };
  
    let data = {
      table: "imetrade",
      method_type: "report_trade",
      from: payload?.from ? (payload.from - 1) * payload.size : 0,
      size: payload?.size,
      data: payload?.data ? payload.data : {},
      sort_by: payload?.sort_by ? payload?.sort_by :{} ,
    };
  
    try {
      
      let res = yield AxiosCustom(config, data); 

    //   let flag = handleNotificationAlertTrySelect(res);
      
    //   if (!flag) return;
      
      yield put({
        type: actionTypes.selectInstruments,
        payload: res.data.response.data
      });
      yield put({type:actionTypes.selectInstrumentsLoad,payload:false})
      
    } catch {
    //   handleNotificationAlertCatch();
    yield put({type:actionTypes.selectInstrumentsLoad,payload:false})
    }
  }
  
  export function* bourseInstrumentsSelect() {
    yield takeLatest(actionTypes.selectInstrumentsAsync, handleWorker);
  }
  